import { useStoredPreference } from '@cmg/auth';

import { getFeatureToggles } from '../../../config/appSettings';
import { USER_PREFERENCE_PREFERENCE_KEYS } from '../../shared/constants/user-preferences';

export const useCalendarRewriteOptInPreference = () => {
  const [isPreferenceEnabled] = useStoredPreference({
    key: USER_PREFERENCE_PREFERENCE_KEYS.CalendarRewriteOptIn,
    storageType: 'Local',
    initialValue: false,
  });

  const { isCalendarRewriteOptInOn } = getFeatureToggles();

  return isCalendarRewriteOptInOn && isPreferenceEnabled;
};
